import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import View from './view';
import GlobeViewport from '../viewports/globe-viewport';
import GlobeController from '../controllers/globe-controller';
export default class GlobeView extends View {
  get ViewportType() {
    return GlobeViewport;
  }

  get ControllerType() {
    return GlobeController;
  }

}

_defineProperty(GlobeView, "displayName", 'GlobeView');
//# sourceMappingURL=globe-view.js.map